import { SagaGenerator, UsersResponse } from "types";
import { companyUsersSliceActions } from "./companyUsersSlice";
import { all, put, select, takeEvery } from "redux-saga/effects";
import { callApi } from "root/appSaga";
import { Api } from "api";
import { getCompanyPublicId } from "features/company/companyDetails";
import { generateAllQueryParams } from "myParkdUtils/utils";


export function* companyUsersSaga(): SagaGenerator {
    return yield all([
        takeEvery(companyUsersSliceActions.getCompanyUsers, getCompanyUsers),
        takeEvery(companyUsersSliceActions.updateCompanyUser, updateCompanyUser),
        takeEvery(companyUsersSliceActions.deleteCompanyUser, deleteCompanyUser),
    ]);
}

export function* getCompanyUsers(params: ReturnType<typeof companyUsersSliceActions.getCompanyUsers>): SagaGenerator {
    try {
        const queryParams = generateAllQueryParams(params.payload);
        const pagedUsers: UsersResponse = yield callApi(Api.getCompanyUsers, queryParams);
        const { users, totalElements, totalPages } = pagedUsers;
        yield put(companyUsersSliceActions.getCompanyUsersCompleted({ users, totalElements, totalPages }));
    } catch (error) {
        yield put(companyUsersSliceActions.getCompanyUsersError({ error }));
        console.error(error);
    }
}

export function* updateCompanyUser(params: ReturnType<typeof companyUsersSliceActions.updateCompanyUser>): SagaGenerator {
    try {
        const { user } = params.payload;
        const companyPublicId = yield select(getCompanyPublicId);
        yield callApi(Api.updateCompanyUser, companyPublicId, user);
        yield put(companyUsersSliceActions.updateCompanyUserCompleted({ user }));
    } catch (error) {
        yield put(companyUsersSliceActions.updateCompanyUserError({ error }));
        console.error(error);
    }
}

export function* deleteCompanyUser(params: ReturnType<typeof companyUsersSliceActions.deleteCompanyUser>): SagaGenerator {
    try {
        const { userPublicId } = params.payload;
        const companyPublicId = yield select(getCompanyPublicId);
        yield callApi(Api.deleteCompanyUser, companyPublicId, userPublicId);
        yield put(companyUsersSliceActions.deleteCompanyUserCompleted({ userPublicId }));
    } catch (error) {
        yield put(companyUsersSliceActions.deleteCompanyUserError({ error }));
        console.error(error);
    }
}
